/*
    Výběr veškerých kategorií
*/
import React,{ Component } from 'react';
import {Query,Mutation} from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import NoItems from '../../../GlobalComponents/NoItems';
import {UPDATE_CATEGORY_PRIORITY,GET_CATEGORIES,DELETE_CATEGORIES} from '../Queries/index.js';
import AddEditCategory from './AddEditCategory';
import Helper from '../../../Library/helper';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import edit from '../../../Public/Images/edit.svg';
import move from '../../../Public/Images/move.svg';
import Notification from '../../../Library/notification';
import CategoryLib from '../Library/category';
import { withApollo } from 'react-apollo';

const INITIAL_STATE = {
    showDeleteCategoryNotifi : false,
    showDoNotDelete:false,
    showAddCategory:false,
    selectedCategoryID:0,
    categoryID:0,
    deleteCat:null,
    selectedItems:[],
    showAddCategory : false,
    showDeleteNotifi:false
}

class allAdminCategories extends Component{


    constructor(props){
        super(props);
        this.state = INITIAL_STATE;
        this.delCategory    = this.delCategory.bind(this);
        this.showDoNotDel   = this.showDoNotDel.bind(this);
        this.openCloseModal = this.openCloseModal.bind(this);
    }


    delCategory(action){
        if(action){
            let categoryIDs = this.state.selectedItems.join(",");
            this.state.deleteCategories({
                variables:{
                    categoryIDs
                }
            });
            
            this.setState(INITIAL_STATE);
        }else{
            this.setState({
                showDeleteNotifi:false
            });
        }
    }

    showDoNotDel(action){
        this.setState({
            showDoNotDelete:action
        });
    }

    openCloseModal(type,categoryID){
        this.setState({
            showAddCategory:type,
            selectedCategoryID:categoryID
        })
    }
    
    /**
     * smazání kategorie
     * @param {*} deleteCategories funkce, která posílá data na server
     * @param {*} categoryID ID kategorie
     */
    
    checkItemToDelete(e,deleteCategories,categoryID){

        var checked = e.target.checked;
        var arr = [...this.state.selectedItems];

        if(!checked){
            for(let i in this.state.selectedItems){
                if(this.state.selectedItems[i] == categoryID){
                    arr.splice(i,1);
                }
            }
        }else{
            arr = [categoryID,...arr];
        }
        
        this.setState({
            deleteCategories,
            selectedItems:arr
        });
  
    }
    
    openCloseAddCategoryModal = (type) => {
        this.setState({
            showAddCategory:type,
        })
    }
    
    showDelNotifi = () => {

        if(this.state.selectedItems.length > 0){
            this.setState({
                showDeleteNotifi:true
            });
        }else{
            let notify = new Notification();
            notify.setNotification(null,'Nevybrali jste kategorii.',false,true,this.props.client);
        }
    }
    onDragEnd = (result,updateCategoryPriority) => {

        const IDs = result.draggableId.split("-");

        updateCategoryPriority({
            variables:{
                categoryID: IDs[0],
                fromIndex:result.source.index,
                toIndex:  result.destination.index
            }
        });

    }

    render(){
        
        const {selectedItems} = this.state;

        return(
            <div id="settings" className="whole-container" >
            	
                <div className="row" >
                    <div className="col-sm one">
                        <div className="card main">
                            
                            <div className="card-header d-flex align-items-center">
                                Seznam kategorií
                                <button className="btn btn-primary btn-thiner ml-auto" onClick={() => this.openCloseModal(true)}>Přidat</button>
                                <button className="btn btn-danger btn-thiner ml-2" onClick={() => this.showDelNotifi()}>Smazat označené</button>
                            </div>
                            <div className="card-body">
                                <Query query={GET_CATEGORIES} errorPolicy="all" variables={{ lang:"cz" }}>
                                    {
                                        ({data,loading,error,refetch }) => {
                                            if(error){
                                                const helper = new Helper(); 
                                                return (<Error text={helper.getApolloErrorText(error)} />);
                                            }
                                            if(loading) return (<Loading />);
                                            
                                            return(
                                                <div>
                                                    <div className="data-list">
                                                        
                                                            <div className="data-list-item header">
                                                                <div className="data-list-item-content">
                                                                    <div>Název kategorie</div>
                                                                    <div className="text-center">Aktivní</div>
                                                                    <div className="text-right">Možnosti</div>
                                                                </div>
                                                            </div>

                                                            <Mutation
                                                                mutation = {DELETE_CATEGORIES}
                                                                update = {async (cache, response) => {
                                                                    
                                                                    let category = new CategoryLib(this);
                                                                    category.updateAfterDeleteCategory(cache, response);

                                                                    let notify = new Notification();
                                                                    notify.setNotification(cache,'Úspěšně smazáno',true,false);
                                                
                                                                }}
                                                                onError = {(error) => {
                                                                    const helper = new Helper(); 
                                                                    let notify = new Notification();
                                                                    notify.setNotification(null,helper.getApolloErrorText(error),false,true,this.props.client);
                                                                }}
                                                            >
                                                                {
                                                                    (deleteCategories,response) => {
                                                                
                                                                        return(
                                                                            <Mutation 
                                                                                mutation={UPDATE_CATEGORY_PRIORITY} 
                                                                                update={() => {
                                                                                    refetch();
                                                                                }}
                                                                            >
                                                                            {
                                                                                (updateCategoryPriority,{error}) => {

                                                                                    if(error){
                                                                                        const helper = new Helper(); 
                                                                                        return (<Error text={helper.getApolloErrorText(error)} />);
                                                                                    }

                                                                                    return (
                                                                                        <DragDropContext onDragEnd={(result) => this.onDragEnd(result,updateCategoryPriority)}>
                                                                                            <Droppable droppableId="droppable">
                                                                                                {(provided, snapshot) => (
                                                                                                    <div
                                                                                                        {...provided.droppableProps}
                                                                                                        ref={provided.innerRef}
                                                                                                    >
                                                                                                        {data.allAdminCategories && data.allAdminCategories.map((item,index) => {
                                                                                                            
                                                                                                            if(item.categoryID){
                                                                                                                
                                                                                                                var checked = false;
                                                                                                                for(let i in selectedItems){
                                                                                                                    if(selectedItems[i] == item.categoryID)checked = true;
                                                                                                                }

                                                                                                                return (
                                                                                                                    <Draggable key={index} draggableId={item.categoryID} index={index}>
                                                                                                                        {(provided, snapshot) => (
                                                                                                                        <div className="data-list-item" 
                                                                                                                            ref={provided.innerRef}
                                                                                                                            {...provided.draggableProps}
                                                                                                                            {...provided.dragHandleProps}
                                                                                                                        >
                                                                                                                            <div className="data-list-item-content categories">
                                                                                                                                <div className="cross" style={{paddingLeft:10}}>
                                                                                                                                    <img className="move-icon" src={move} />
                                                                                                                                    {item.name}
                                                                                                                                </div>
                                                                                                                                <div className="text-center">{(item.active == 1 ? "Ano" : "Ne" )}</div>
                                                                                                                                <div className="text-right">
                                                                                                                                    <img onClick={() => this.openCloseModal(true,item.categoryID)} className="edit-icon" src={edit} /> 
                                                                                                                                    <input className="delete-checked" type="checkbox" name="categoriesToDelete[]" checked={checked} onChange = {(e) => this.checkItemToDelete(e,deleteCategories,item.categoryID)} />
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        )}
                                                                                                                    </Draggable>
                                                                                                                )
                                                                                                            }else{
                                                                                                                return "";
                                                                                                            }
                                                                                                        })}
                                                                                                        {provided.placeholder}
                                                                                                    </div>
                                                                                                )}
                                                                                            </Droppable>
                                                                                        </DragDropContext>
                                                                                    )
                                                                            }}
                                                                            </Mutation>
                                                                        )
                                                                    }
                                                                }
                                                            </Mutation>
                                                        
                                                    </div>
                                                    {data.allAdminCategories && data.allAdminCategories.length == 0 &&
                                                        <NoItems text={"Momentálně se zde nenachází žádné kategorie."} />
                                                    }
                                                    {this.state.showDeleteNotifi && <ModalNotification yesNo={true} text={'Opravdu chcete vymazat tuto kategorii ?'} callback={this.delCategory} /> }
                                                    {this.state.showAddCategory &&
                                                        <AddEditCategory openCloseModal={this.openCloseModal} selectedCategoryID={this.state.selectedCategoryID} />
                                                    }
                                                </div>
                                            );
                                        }
                                    }
                                </Query>
                            </div>
                        </div>
                    </div>
                </div> 			
            </div>
        
        );

    }

}


export default withApollo(allAdminCategories);